<template>
  <UtilityFormField
    title="Email"
    field-id="email"
    :error="showValidation ? error : undefined"
  >
    <input
      id="email"
      ref="input"
      :value="modelValue"
      :disabled="disabled"
      type="email"
      name="email"
      data-input="text"
      autocomplete="email"
      required
      @input="
        $emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
      @blur="showValidation = true"
    />
  </UtilityFormField>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AccountFieldEmail',
  props: {
    disabled: { type: Boolean, default: false },
    modelValue: { type: String, required: true },
  },
  emits: {
    'update:modelValue': (_value: string) => true,
  },
  data() {
    return {
      error: '',
      showValidation: false,
    };
  },
  watch: {
    modelValue() {
      const input = this.$refs.input as HTMLInputElement;
      this.error = input.validationMessage;
    },
  },
});
</script>
